import { INIT_KEYCLOCK } from './constants';

export const loadInitKeycloak = () => ({ type: INIT_KEYCLOCK });
